import { gql, useMutation } from '@apollo/client';

const SEND_PASTE_MUTATION = gql`
    mutation SendPaste($paste: PasteDTO!){
        sendPaste(paste: $paste) {
            id
            content
            timestamp
            receiver
        }
    }
`;

export default function useSendPaste() {
    const [sendPaste, { data, loading, error }] = useMutation(SEND_PASTE_MUTATION);
    return {sendPaste, data, loading, error}
}